import { render } from "./v-sudya.vue?vue&type=template&id=8f4d0002"
import script from "./v-sudya.vue?vue&type=script&lang=js"
export * from "./v-sudya.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__